import { render } from "./ItemListDisplay.vue?vue&type=template&id=2b0eb744&scoped=true"
import script from "./ItemListDisplay.vue?vue&type=script&lang=js"
export * from "./ItemListDisplay.vue?vue&type=script&lang=js"

import "./ItemListDisplay.vue?vue&type=style&index=0&id=2b0eb744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0eb744"]])

export default __exports__